import { GET_USER_GENERAL_SETTINGS, UPDATE_USER_GENERAL_SETTINGS } from '../../types'

const initialState = {
  general: {
    firstName: '',
    lastName: '',
    jobTitle: '',
    cellPhone: null,
    officePhone: null,
    samePhone: 0,
    emailAddress: '',
    enableSMS: 0,
    defaultPage: '',
    defaultReport: '',
    defaultView: '',
    defaultCaptureCount: '',
    avatarKey: '',
    avatarPath: ''
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USER_GENERAL_SETTINGS: return {
      ...state,
      general: action.payload
    }
    case UPDATE_USER_GENERAL_SETTINGS: return {
      ...state,
      general: action.payload
    }
    default: return { ...state }
  }
}
